<template>
  <v-dialog
      class="hide-on-print"
      v-model="innerOpen"
      persistent
      width="800">

    <v-card class="hide-on-print">
      <v-toolbar color="blue darken-3" dark>
        <v-toolbar-title>Apply penalty</v-toolbar-title>
      </v-toolbar>
      <v-toolbar-title></v-toolbar-title>

      <v-card-text class="pa-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <FormErrorDisplayHandler :errors="errors"/>
            <v-flex xs12>
              <v-form class="pa-2" lazy-validation ref="manualRef">
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                        label="Amount (NPR) *"
                        outlined
                        type="number"
                        :hint="'Exchange rate of NPR ' + npr_rate"
                        v-model="paymentData.amount"
                        :rules="[
                            rules.required,
                            val => val > 0 || 'Must be greater than 0',
                            val => val <= 50000 || 'Must be less than 50000'
                        ]"
                        :error-messages="errorMessage"
                        onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                    />
                  </v-flex>
                  <v-flex xs6 class="pr-2">
                    <v-text-field
                        label="Amount (USD) *"
                        outlined
                        :disabled="true"
                        type="number"
                        :value="usdAmount"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        label="Remarks"
                        outlined
                        v-model="paymentData.remarks"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <multiple-file-upload
                        v-model="paymentData.files"
                        label="Files (If any)"
                    />
                  </v-flex>

                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider style="margin-top:31px;"/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            @click="cancel"
            class="white--text"
            color="red darken-3"
        >Cancel
        </v-btn>
        <v-btn
            @click="save"
            class="white--text"
            color="blue darken-3"
        >Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {validationMixin} from "../../mixins/validationMixin";
import {VERSIONED_API_URL} from "../../config/config";
import Http from "axios"
import MultipleFileUpload from "../MultipleFileUpload";
import FormErrorDisplayHandler from "../FormErrorDisplayHandler";

export default {
  name: "CertificationPenaltyDialog",
  components: {MultipleFileUpload, FormErrorDisplayHandler},
  props: ['value', 'id'],
  mixins: [validationMixin],

  data() {
    return {
      paymentData: {},
      innerOpen: false,
      errorMessage: '',
      npr_rate: null,
      errors: [],
    }
  },

  computed: {
    usdAmount() {
      if (this.paymentData.amount > 0) {
        const amount = this.paymentData.amount / this.npr_rate;
        return amount.toFixed(3);
      }

      return 0;
    }
  },
  watch: {
    value(input) {
      if (input) {
        Http.get(`${VERSIONED_API_URL}/get-npr-rate`).then((res) => {
          this.npr_rate = res.data
        })
      }
      this.innerOpen = input;
    },
    innerOpen(value) {
    }
  },
  async mounted() {
    if (this.value) {
      this.innerOpen = this.value;
    }
  },
  methods: {
    async save() {
      if (this.$refs.manualRef.validate()) {
        try {
          const formData = new FormData();
          formData.append('amount', this.usdAmount);
          formData.append("amount_npr", this.paymentData.amount)
          formData.append('remarks', this.paymentData.remarks);
          if (this.paymentData.files !== undefined) {
            for (let i = 0; i < this.paymentData.files.length; i++) {
              formData.append(`files[${i}]`, this.paymentData.files[i])
            }
          }
          const response = await Http.post(VERSIONED_API_URL + '/certifications/apply-penalty/' + this.id, formData);
          this.$store.commit('Notification/showSuccess', response.data.message);
          this.paymentData = {};
          this.$emit('input', false);
          this.innerOpen = false;
          this.$emit('applied', response.data.amount)

        } catch (e) {
          console.log(e);
          this.$store.commit('Notification/showError', e.response.data.message);
        }
      }
    },
    cancel() {
      this.paymentData = {};
      this.innerOpen = false;
      this.$emit('input', false)
    }
  }
}
</script>

